// Function to retrieve a specific cookie by name

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function getCookie(name) {
    console.log("document.cookie",document.cookie)
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    console.log(parts, parts.length);
    if (parts.length === 2) return JSON.parse(parts.pop().split(';').shift()).unique_number || 0;
    if (parts.length === 1 && isJsonString(parts[1])) {
        return JSON.parse(parts.pop().split(';')[1]).unique_number || 0;   
    }
    return null;
}

// Function to handle button click
function handleButtonClick(event) {
    console.log(event)
    const buttonValue = parseInt(event); // Get button value as integer
    const cookieId = getCookie('tracker_data'); // Retrieve the 'id' cookie

    if (cookieId != null) {
        const url = new URL('https://partnersapi-stg.stackflow.org/tracker/logs/vendor/save');
        url.searchParams.append('id', buttonValue);
        url.searchParams.append('uniqueNumber', cookieId || '');
        // console.log("JSON",url.toString())
        $.ajax({
            url: url.toString(), // The URL with query parameters
            type: 'GET',
            success: function(response) {
                // console.log('API Response:', response);
            },
            error: function(xhr, status, error) {
                console.error('Error:', {
                    status: status,
                    error: error,
                    responseText: xhr.responseText,
                    responseStatus: xhr.status
                });
            }
        });
    }
}

export default handleButtonClick;

// Add event listener to the button
// document.getElementById('myButton').addEventListener('click', handleButtonClick);



// WEBPACK FOOTER //
// ./src/plugins/buttonHandler.js